import { render, staticRenderFns } from "./updateContentsModal.vue?vue&type=template&id=6efb0eb8&scoped=true"
import script from "./updateContentsModal.vue?vue&type=script&lang=js"
export * from "./updateContentsModal.vue?vue&type=script&lang=js"
import style0 from "./updateContentsModal.vue?vue&type=style&index=0&id=6efb0eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb0eb8",
  null
  
)

export default component.exports